import { IntEnumConditions } from '../../../grid/gridFilters/types';
import { ColumnDetails } from '../../../grid/types/common';

export const INVESTIGATION_ACTIVITIES = {
  COLLECT_INVESTIGATION_PACKAGE: 1,
  REMOTE_SHELL_DOWNLOAD: 2,
};

export enum Column { // column indexes
  FILE_NAME,
  ACTIVITY,
  STARTED_ON,
  FINISHED_ON,
  FILE_EXPIRES_ON,
  STATUS,
  ACTION,
}

export enum ColumnKeys {
  FILE_NAME = 'fileName',
  STARTED_ON = 'startDate',
  FINISHED_ON = 'endDate',
  FILE_EXPIRES_ON = 'fileExpirationDate',
  ACTIVITY = 'activity',
  STATUS = 'status',
  ACTION = 'action',
}

export const POSSIBLE_ACTIONS = {
  CANCEL: 1,
  SEE_DETAILS: 2,
  DOWNLOAD_FILE: 3,
  RETRIEVE_FILE: 4,
};

export const STATUS = {
  PENDING: 1,
  IN_PROGRESS: 2,
  FAILED: 3,
  FINISHED: 4,
  TO_BE_RETRIEVED: 6,
};

export const PREDEFINED_FILTERS_KEYS = [];

export interface Filter {
  status?: IntEnumConditions;
}

export interface GridItem {
  id: string;
  startDate: string;
  endDate?: string;
  status: number;
  activity: number;
  fileName?: string;
  fileExpiresOn?: string;
  action: string;
}

export interface View {
  id: string;
  name: string;
  type: number;
  selectedTargets: Array<string>;
  displayedColumns: Array<number>;
  filters?: Array<Filter>;
  compactView?: boolean;
  pageSize: number;
}

export interface ActivityGridViewData {
  targets: Array<string>;
  isPartner: boolean;
  allColumns: Array<ColumnDetails<Column, ColumnKeys>>;
  views: Array<View>;
  defaultViewProps: View;
}

export interface GetDataGridItemsResponse {
  rawEvents?: Array<GridItem>;
}

export interface SetFiltersRequest {
  viewId: string;
  filters: Array<Filter>;
}

export interface UpdateSettingsRequest {
  viewId: string;
  columns?: Array<Column>;
  compactView?: boolean;
  pageSize?: number;
}
